export const PLEASE_ENTER_EMAIL = 'pleaseEnterEmail'
export const PLEASE_ENTER_VALID_EMAIL = 'pleaseEnterValidEmail'
export const EMAIL_MUST_NOT_BE_GREATER_THAN_256 = 'emailMustNotBeGreaterThan'
export const PLEASE_ENTER_PHONE = 'pleaseEnterPhone'
export const MOBILE_PHONE_MUST_NOT_BE_GREATER_THAN_16 = 'mobilePhoneMustNotBeGreaterThan16'
export const MOBILE_PHONE_MUST_NOT_BE_LESS_THAN_8 = 'mobilePhoneMustNotBeLessThan8'
